import { ITransactionEffectiveDateComment } from '@zunta/configurations'
import ApiInstance from './instance'

export default class ClaimFlowApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  async getTransactionComments (tedId: number | string): Promise<ITransactionEffectiveDateComment[]> {
    return this.instance.doGet(`/claim/tasks/${tedId}/comments`)
  }

  async addComment (claimTaskId: number | string, text: string, baseComment: number | null): Promise<ITransactionEffectiveDateComment> {
    return this.instance.doPost(`/claim/tasks/${claimTaskId}/comments/add`, {
      text,
      baseComment
    })
  }
}
